<template>
    <div class="input-container" :class="{ half: input.half }">
        <label :for="id" v-text="input.display" :class="{ required: input.required }"></label>
        <input :id="id" :placeholder="input.placeHolder" :maxlength="input.maxlength ? input.maxlength : ''" :type="input.type" v-model="formattedValue" ref="input" @input="formatValue" />
    </div>
</template>
<script>
export default {
  name: 'InputComponent',
  props: ['input'],
  data () {
    return {
      id: this.getId(this.input.display),
      inputValue: '',
      formattedValue: ''
    }
  },
  methods: {
    getId: function (display) {
      return display.replaceAll(' ', '').toLowerCase().normalize('NFD').replace(/[^a-zA-Z\s]/g, '')
    },
    getValue: function () {
      return this.$refs.input.value
    },
    formatValue: function () {
      if (this.input.format === 'cardNumber') {
        this.formattedValue = this.getValue().replace(/\D/g, '') // Remove tudo o que não é dígito
        this.formattedValue = this.formattedValue.replace(/(\d{4})(\d)/, '$1 $2').replace(/(\d{4})(\d)/, '$1 $2').replace(/(\d{4})(\d)/, '$1 $2')
        this.formattedValue = this.fixInputLength(this.formattedValue, 19)
      } else if (this.input.format === 'cardDate') {
        this.formattedValue = this.getValue().replace(/\D/g, '')
        this.formattedValue = this.formattedValue.replace(/(\d{2})(\d)/, '$1/$2')
        this.formattedValue = this.fixInputLength(this.formattedValue, 5)
      } else if (this.input.format === 'cardCVV') {
        this.formattedValue = this.getValue().replace(/\D/g, '')
        this.formattedValue = this.fixInputLength(this.formattedValue, 4)
      } else if (this.input.format === 'cellNumber') {
        this.formattedValue = this.getValue().replace(/\D/g, '')
        this.formattedValue = this.formattedValue.replace(/(\d{2})(\d)/, '($1) $2')
        this.formattedValue = this.formattedValue.replace(/(\d{5})(\d)/, '$1-$2')
        this.formattedValue = this.fixInputLength(this.formattedValue, 15)
      } else if (this.input.format === 'phoneNumber') {
        this.formattedValue = this.getValue().replace(/\D/g, '')
        this.formattedValue = this.formattedValue.replace(/(\d{2})(\d)/, '($1) $2')
        this.formattedValue = this.formattedValue.replace(/(\d{4})(\d)/, '$1-$2')
        this.formattedValue = this.fixInputLength(this.formattedValue, 14)
      } else if (this.input.format === 'cpf') {
        this.formattedValue = this.getValue().replace(/\D/g, '')
        this.formattedValue = this.formattedValue.replace(/(\d{3})(\d)/, '$1.$2')
        this.formattedValue = this.formattedValue.replace(/(\d{3})(\d)/, '$1.$2')
        this.formattedValue = this.formattedValue.replace(/(\d{3})(\d)/, '$1-$2')
        this.formattedValue = this.fixInputLength(this.formattedValue, 14)
      } else if (this.input.format === 'cep') {
        this.formattedValue = this.getValue().replace(/\D/g, '')
        this.formattedValue = this.formattedValue.replace(/(\d{5})(\d)/, '$1-$2')
        this.formattedValue = this.fixInputLength(this.formattedValue, 9)
      } else if (this.input.format === 'userName') {
        this.formattedValue = this.getValue().replace(/[^a-zA-Z0-9]+/g, '')
      } else {
        this.formattedValue = this.getValue()
      }
    },
    fixInputLength (inputValue, length) {
      if (inputValue.length > length) {
        inputValue = inputValue.slice(0, length)
      }
      return inputValue
    }
  }
}
</script>

<style lang="less" scoped>
.input-container {
  margin-bottom: 15px;
  font-size: 16px;

    &.half {
        width: calc(50% - 10px);
    }

    // no half
    &:not(.half) {
        display: block;
        width: calc(100%);
    }

    label {
        display: block;
        margin-bottom: 5px;

        &.required:after {
        content: '*';
        color: var(--primaryColor);
        margin-left: 5px;
        }
    }

    input {
        width: calc(100% - 30px);
        padding: 15px;
        font-size: 16px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 7px;
        margin-top: 10px;
    }
}
</style>
